// controllers/behavior-controller.ts
import { BehaviorSubject, distinctUntilChanged, pairwise } from "rxjs";
import "./chemistry-controller";
var BehaviorController = class extends BehaviorSubject {
  constructor(host, startValue) {
    super(startValue);
    (this.host = host).addController(this);
  }
  get propertyName() {
    if (!this._propertyName) {
      let propertyName = Object.keys(this.host).find((propertyKey) => this.host[propertyKey] === this);
      if (propertyName.startsWith("__"))
        propertyName = propertyName.replace(/^__/, "");
      this._propertyName = propertyName;
    }
    return this._propertyName;
  }
  hostConnected() {
    if (!this.subscription)
      this.subscription = this.pipe(
        distinctUntilChanged((a, b) => typeof a !== "object" && typeof b !== "object" && a === b),
        pairwise()
      ).subscribe(([oldValue]) => this.host.requestUpdate(this.propertyName, oldValue));
  }
  hostDisconnected() {
    if (this.subscription)
      this.subscription.unsubscribe();
    this.subscription = void 0;
  }
};
export {
  BehaviorController
};
